"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * [[SignalingClientConnectionRequest]] represents an connection request.
 */
var SignalingClientConnectionRequest = /*#__PURE__*/function () {
  /** Creates a request with the given URL, conference id, and join token.
   *
   * @param signalingURL The URL of the signaling proxy.
   * @param joinToken The join token that will authenticate the connection.
   */
  function SignalingClientConnectionRequest(signalingURL, joinToken) {
    _classCallCheck(this, SignalingClientConnectionRequest);
    this.signalingURL = signalingURL;
    this.joinToken = joinToken;
  }
  /** Gets the signaling URL representing this request.*/
  _createClass(SignalingClientConnectionRequest, [{
    key: "url",
    value: function url() {
      return this.signalingURL + '?X-Chime-Control-Protocol-Version=3&X-Amzn-Chime-Send-Close-On-Error=1';
    } /** Gets the protocols associated with this request.*/
  }, {
    key: "protocols",
    value: function protocols() {
      return ['_aws_wt_session', this.joinToken];
    }
  }]);
  return SignalingClientConnectionRequest;
}();
exports.default = SignalingClientConnectionRequest;